// スタッフ詳細：過去のコメントの開閉
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('comment_btn');
  const old = document.getElementById('old_comments');
  if (!btn || !old) return;
  btn.addEventListener('click', () => {
    btn.style.display = 'none';
    old.style.opacity = '0';
    old.style.display = 'block';
    old.style.transition = 'opacity 0.7s ease';
    requestAnimationFrame(() => (old.style.opacity = '1'));
  });
});
